module.exports = __webpack_public_path__ + "img/banker-gold-page_900.61456766.png";